export default {
  ['analytics']: 0,
  ['affiliates']: 1,
  ['display_ads']: 0,
  ['search']: 1,
  ['email']: 1,
  ['personalization']: 0,
  ['social']: 1,
  ['big_data']: 1,
  ['misc']: 1,
  ['cookiematch']: 1,
  ['cdp']: 1,
  ['mobile']: 1,
  ['engagement']: 1,
  ['monitoring']: 1,
  ['crm']: 1
};
